"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_SigilOfBloodEffectHandler = exports.Passive_SigilOfBloodEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Target_1 = require("../../Target");
const Schedule_1 = require("../../Schedule");
const EventType_1 = require("../../events/EventType");
class Passive_SigilOfBloodEffectArgs {
    constructor(percent) {
        this.percent = percent;
        this.__type = EffectType_1.EffectType.Passive_SigilOfBlood;
        this.__typeName = "Passive_SigilOfBlood";
        this.name = "Sigil of Blood";
        this.harmful = false;
    }
}
exports.Passive_SigilOfBloodEffectArgs = Passive_SigilOfBloodEffectArgs;
let Passive_SigilOfBloodEffectHandler = class Passive_SigilOfBloodEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandlerScript(state.creatorId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, "Effect_Leech_OnDamageDealt", {
            percent: state.args.percent,
            target: Target_1.Target.AllAllies
        });
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
Passive_SigilOfBloodEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_SigilOfBlood)
], Passive_SigilOfBloodEffectHandler);
exports.Passive_SigilOfBloodEffectHandler = Passive_SigilOfBloodEffectHandler;
